import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export interface IconUIComponentProps {
  className?: string;
  color?: string;
  size?: number | string | undefined;
  style?: React.CSSProperties;
  noFill?: boolean;
}

interface HookProps {
  noFill?: boolean;
}

export const useIconStyle = makeStyles<Theme, HookProps>(
  theme =>
    createStyles({
      icon: {
        fill: props => props.noFill ? 'none' : 'currentColor',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        fontSize: '1.5em',
        flexShrink: 0,
        userSelect: 'none',
      },
    }),
  {
    classNamePrefix: 'icon-ui-component',
  }
);
